<template>
  <section class="p-2">
    <v-card>
      <!--         $route.query.name !== 'Transaction Limit' -->
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Setup Master Data Value</div>
        <div>
          <bread-crumb :bread-crumbs="['Master Data', 'Master Data Value']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid" class="px-2">
            <v-row row-gutters class="align-items-center">
              <v-col cols="12" lg="3" md="3" sm="12">
                <v-autocomplete
                  class="rounded"
                  v-model="searchInputs.customer_type"
                  dense
                  outlined
                  :items="user_types"
                  label="User Type"
                  placeholder="Select User Type"
                ></v-autocomplete>
              </v-col>
              <v-col>
                <v-btn
                  depressed
                  small
                  class="ms-3 mb-6 primary text-capitalize"
                  @click="getallparametersvalue()"
                  >Get Results</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-card>
        <v-card-title>
          <v-row class=" ">
            <!-- <v-btn
              depressed
              small
              class="mx-2 mt-2 px-5 text-capitalize"
              color="primary"
              @click="back()"
              outlined
            >
              <v-icon left>mdi-arrow-left</v-icon>
              Back</v-btn
            > -->
            <!---------------------------------- Add value dialog (add master data value) start------------------------------- -->
            <v-dialog persistent max-width="400px" v-model="dialog">
              <template v-slot:activator="{ on, attrs }">
                <v-row class="mt-0">
                  <v-col>
                    <v-btn
                      v-if="!is_sub_parameter"
                      depressed
                      small
                      color="primary"
                      @click="openDialog()"
                      dark
                      class="mx-2 mt-2 px-5 text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >
                      Add Value
                    </v-btn>
                    <v-btn
                      depressed
                      class="mt-2"
                      @click="downloadExcelsheet"
                      color="primary"
                      small
                      ><v-icon small>mdi-file-excel-outline</v-icon>Export
                    </v-btn>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </template>

              <v-card>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-toolbar color="grey lighten-3 font-weight-bold" flat dense>
                    <span class="subtitleFontsize">{{ formtitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed icon @click="onClickBack()">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text class="">
                    <v-row class="">
                      <v-col cols="12" md="12">
                        <label class="my-0 labelFontsize required"
                          >User Type</label
                        >
                        <v-autocomplete
                          class="rounded"
                          v-model="prametervalues.user_type"
                          dense
                          outlined
                          :items="userTypeDropdown"
                          :rules="FieldRequired('User Type')"
                          placeholder="Select User Type"
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        md="12"
                        v-if="masterDataRange.includes($route.query.code)"
                      >
                        <label class="my-0 mb-4 labelFontsize required"
                          >Name</label
                        >
                        <v-row>
                          <v-col>
                            <v-text-field
                              type="number"
                              dense
                              outlined
                              placeholder="Min Value"
                              v-model="parameter_minvalue"
                              @keydown="onnumberKeyDown"
                              class="rounded"
                              hide-spin-buttons
                              :rules="parameter_minmax"
                            >
                            </v-text-field> </v-col
                          >-
                          <v-col>
                            <v-text-field
                              dense
                              outlined
                              type="number"
                              @keydown="onnumberKeyDown"
                              placeholder="Max value"
                              v-model="parameter_maxvalue"
                              class="rounded"
                              hide-spin-buttons
                              :rules="parameter_minmax"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12" md="12" v-else>
                        <label class="my-0 labelFontsize required">Name</label>

                        <v-text-field
                          dense
                          outlined
                          placeholder="Value Name"
                          v-model="prametervalues.value"
                          class="rounded"
                          :rules="value_Name"
                          @input="validateparameterName()"
                        >
                        </v-text-field>
                        <span
                          v-if="prametervalues.value"
                          v-bind:style="{
                            color: isnameavalaible.success
                              ? 'green !important'
                              : ' red !important',
                          }"
                          class="caption"
                        >
                          {{ isnameavalaible.message }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label class="my-0 labelFontsize required"> Code</label>
                        <v-text-field
                          placeholder="Value Code"
                          dense
                          outlined
                          v-model="prametervalues.value_code"
                          class="rounded"
                          @input="validateparameterCode()"
                        >
                        </v-text-field>
                        <span
                          v-if="prametervalues.value_code"
                          :style="{
                            color: isavalaiblevalue.success
                              ? 'green !important'
                              : ' red !important',
                          }"
                          class="caption"
                        >
                          {{ isavalaiblevalue.message }}
                        </span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label class="my-0 labelFontsize required">
                          Description</label
                        >
                        <v-text-field
                          placeholder="Description"
                          dense
                          outlined
                          :rules="descrption"
                          v-model="prametervalues.description"
                          class="rounded"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <div class="d-flex justify-center mt-4 mb-4">
                    <v-btn
                      depressed
                      small
                      color="primary"
                      min-width="170px"
                      @click="onclickNext()"
                      v-if="!prametervalues.id"
                      class="me-3 text-capitalize"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >Add
                    </v-btn>

                    <v-btn
                      depressed
                      small
                      color="primary"
                      min-width="170px"
                      @click="onClickBack()"
                      v-if="!prametervalues.id"
                      class="text-capitalize ms-3"
                      outlined
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >Cancel
                    </v-btn>
                  </div>
                  <div class="d-flex mb-4 justify-center">
                    <v-btn
                      depressed
                      small
                      color="primary"
                      min-width="170px"
                      @click="onupdate()"
                      v-if="prametervalues.id"
                      class="me-3 text-capitalize"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-edit-outline</v-icon
                      >
                      Update
                    </v-btn>

                    <v-btn
                      depressed
                      small
                      color="primary"
                      outlined
                      min-width="170px"
                      @click="onClickBack()"
                      v-if="prametervalues.id"
                      class="text-capitalize ms-2"
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >
                      Cancel
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-dialog>
            <!---------------------------------- Add value dialog (add master data value) end------------------------------- -->

            <!---------------------------------------- add category from the sub category start  -------------------------------->
            <addCatmastervalue
              v-if="showButton"
              :selectedItems="selectedItems"
              :prameterid="$route.query.id"
            />
            <!---------------------------------------- add category from the sub category end  -------------------------------->
            <v-dialog v-model="dialogDelete" width="500">
              <v-card>
                <v-card-title class="border border-bottom">Delete</v-card-title>
                <v-card-text class="h5 py-3"
                  >Are you sure you want to delete this prameter?</v-card-text
                >
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    depressed
                    small
                    color="primary"
                    outlined
                    @click="deleteItemConfirm"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                  <v-btn
                    depressed
                    small
                    color="primary"
                    outlined
                    @click="closeDelete"
                    ><v-icon>mdi-close</v-icon></v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-card-title>

        <template>
          <v-row class="mt-5">
            <v-col cols="12" md="5" lg="5" xs="12" class="mt-3">
              <label class="" style="font-size: 14px">
                Master Parameter:
                <span class="ms-1 font-weight-bold">{{
                  $route.query.name
                }}</span></label
              >
            </v-col>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!is_sub_parameter"
              depressed
              @click="openExportDialog()"
              color="primary"
              small
              ><v-icon small>mdi-file-excel-outline</v-icon>Import
            </v-btn>
            <a
              v-if="!is_sub_parameter"
              title="Download Sample Excel File"
              href="/sample_masterdata_import.xlsx"
              download
              class="ms-2 samplefile"
            >
              <v-icon color="primary" size="28">mdi-file-download</v-icon></a
            >

            <v-col cols="12" lg="5" xs="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                single-line
                class="me-4 mx-2"
                dense
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </template>
        <!---------------------------------- Master data value table  start------------------------------------------>
        <v-data-table
          fixed-header
          height="55vh"
          :headers="headers"
          dense
          :search="search"
          class="p-1"
          :items="allparametersvalues"
          :loading="isLoading"
          loading-text="Loading... Please wait"
          :show-select="!is_sub_parameter"
          @item-expanded="loadDetails"
          :items-per-page="-1"
          v-model="selectedItems"
        >
          <!-- <template v-slot:expanded-item="{ item }">
            <v-sample-table>
              <tbody>
                <tr>
                  <td v-for="source in item.sources" :key="source">
                    {{ source.id }}
                  </td>
                  <td v-for="source in item.sources" :key="source">
                    {{ source.value }}
                  </td>
                  <td v-for="source in item.sources" :key="source">
                    {{ source.value_code }}
                  </td>
                  <td v-for="source in item.sources" :key="source">
                    {{ source.description }}
                  </td>
                </tr>
              </tbody>
            </v-sample-table>
          </template> -->
          <template v-slot:item.user_type="{ item }">
            <span>
              {{ returnUsertype(item.user_type) }}
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-switch
                v-model="item.is_active"
                height="0px"
                color="success"
                dense
                @change="isactiveupdate(item)"
              ></v-switch>
              <v-icon
                small
                v-if="!is_sub_parameter"
                color="primary"
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-content-save-edit-outline
              </v-icon>
              <v-icon
                v-if="!is_sub_parameter"
                small
                color="primary"
                @click="deleteItem(item)"
              >
                mdi-trash-can-outline
              </v-icon>
              <v-icon
                v-if="is_sub_parameter"
                color="grey"
                class="mr-2"
                @click="nextpage(item)"
              >
                mdi-chevron-right-circle
              </v-icon>
            </div>
          </template>
        </v-data-table>
        <v-dialog persistent max-width="400px" v-model="exportDialog">
          <v-card>
            <v-form v-model="valid" ref="uploadform">
              <v-toolbar color="secondary" flat dark dense>
                <span>Upload Excel File</span>
                <v-spacer></v-spacer>
                <v-btn depressed icon @click="closeExportDialog()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-col class="mt-2"> </v-col>
              <v-card-text class="my-3">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-file-input
                      v-model="document"
                      chips
                      prepend-icon=""
                      :rules="[(v) => !!v || 'Please Upload File']"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      ref="file"
                      outlined
                      dense
                      label="Upload File"
                      placeholder="No File Choosen"
                      :persistent-placeholder="true"
                      clearable
                    >
                      <template v-slot:append>
                        <v-icon
                          v-if="showChoosefile"
                          color="primary"
                          class="mb-2"
                          @click="open"
                        >
                          mdi-cloud-upload
                        </v-icon>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
                <div class="d-flex justify-center align">
                  <v-col
                    min-width="325px"
                    class="primary--text font-weight-bold border pa-2"
                  >
                    <v-icon small color="primary"
                      >mdi mdi-check-decagram</v-icon
                    >
                    Total Records -{{ total_records ? total_records : 0 }}
                  </v-col>
                </div>
                <div class="d-flex justify-center align">
                  <v-col min-width="170px" class="text-success border pa-2">
                    <v-icon small color="success"
                      >mdi mdi-check-decagram</v-icon
                    >
                    Success -{{ success ? success : 0 }}
                  </v-col>
                  <v-col min-width="170px" class="text-red border pa-2">
                    <v-icon small color="error">mdi mdi-check-decagram</v-icon>
                    Failed -{{ failure ? failure : 0 }}
                  </v-col>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <div class="ma-2 float-right">
                <v-btn
                  depressed
                  small
                  outlined
                  color="primary"
                  @click="closeExportDialog()"
                  class="text-capitalize"
                >
                  <v-icon small class="me-2">mdi-close-circle-outline</v-icon
                  >Close
                </v-btn>
                <v-btn
                  depressed
                  small
                  color="primary"
                  class="ms-2 text-capitalize"
                  @click="SubmitFile()"
                >
                  <v-icon small class="me-2"
                    >mdi-content-save-plus-outline</v-icon
                  >Upload
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <!---------------------------------- Master data value table  end------------------------------------------>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
    <!---------------------------------------- age group -------------------------------->
    <!-- <ageGroup v-if="$route.query.name === 'Age Group'" /> -->
    <!---------------------------------------- age group -------------------------------->

    <!---------------------------------------- Transaction Limit -------------------------------->
    <!-- <transLimts v-if="$route.query.name === 'Transaction Limit'" /> -->
    <!---------------------------------------- Transaction Limit -------------------------------->
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import { FieldRequired } from "@/utils/validation.js";
import { Masterdatavalue } from "@/utils/validationCopy.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import addCatmastervalue from "./addCatmastervalue.vue";
import setupService from "@/services/SetupService/setupService.js";
import commonService from "@/services/CommonService/commonService.js";
// import ageGroup from "./ageGroup.vue";
// import transLimts from "./transLimts.vue"
import {
  returnRnagemasterData,
  onnumberKeyDown,
} from "@/utils/ConstantDropdowns/masterDataRange.js";
export default {
  components: {
    BreadCrumb,
    Loading,
    // ageGroup,
    addCatmastervalue,
    // transLimts,
  },
  name: "Master Data Value",
  mixins: [alerts],
  data() {
    return {
      ...Masterdatavalue,
      FieldRequired,
      masterDataRange: returnRnagemasterData(),
      onnumberKeyDown,
      dialogDelete: false,
      dialog: false,
      document: null,
      showChoosefile: true,
      // dialogs: false,
      isLoading: false,
      loader: false,
      singleSelect: false,
      valid: true,
      exportDialog: false,
      excelDetails: false,
      search: "",
      selected: "option1",
      is_active: "",
      deleteId: "",
      user_types: [
        {
          text: "Individual",
          value: "IND",
        },
        {
          text: "Business",
          value: "BUS",
        },
        {
          text: "All",
          value: "ALL",
        },
      ],
      headers: [
        {
          text: "ID",
          value: "id",
          width: 130,
        },
        { text: "User Type", value: "user_type", sortable: false },
        { text: "Name", value: "value" },
        { text: "Code", value: "value_code", width: 300 },
        { text: "Descripition", value: "description" },
        { text: "Action", value: "actions", sortable: false },
      ],
      allparametersvalues: [],
      is_sub_parameter: false,
      selectedItems: [],
      editedIndex: -1,
      prametervalues: {
        user_type: "IND",
        value: "",
        value_code: "",
        description: "",
      },
      defaultItem: {
        user_type: "",
        value: "",
        value_code: "",
        description: "",
      },

      isavalaiblevalue: {},
      isnameavalaible: {},
      isavalaiblecode: {},
      parameter_maxvalue: null,
      parameter_minvalue: null,
      success: "",
      failure: "",
      total_records: "",
      searchInputs: {
        customer_type: "IND",
      },
    };
  },

  computed: {
    showButton() {
      return this.selectedItems.length > 0;
    },
    formtitle() {
      return this.editedIndex === -1 ? "Add Value" : "Edit Value";
    },
  },

  watch: {
    dialog(val) {
      val || this.onClickBack();
    },
    "searchInputs.customer_type"(val) {
      if (val) {
        this.parameter_values.user_type = val;
      }
    },
  },
  mounted() {
    this.prametervalues.parameter_code = this.$route.query.code;
    this.prametervalues.parameter_id = this.$route.query.id;
    this.prametervalues.parameter = this.$route.query.name;
    this.getallparametersvalue();
    this.getParametersByCode("UTP");
    // this.valueallparameters();
    console.log("route.query.code  " + JSON.stringify(this.$route.query.code));
    console.log("route.query.name  " + JSON.stringify(this.$route.query.name));
    console.log("route.query.id  " + JSON.stringify(this.$route.query.id));
  },

  methods: {
    returnUsertype(val) {
      if (val == "IND") {
        return "Individual";
      } else if (val == "BUS") {
        return "Business";
      } else if (val == "BOT") {
        return "Both";
      } else {
        return val;
      }
    },
    nextpage(item) {
      console.log("item " + item);
      this.$router.push({
        name: "Sub CategoryValue",
        query: {
          code: item.value_code,
          name: item.value,
          id: item.id,
        },
      });
    },
    loadDetails(item) {
      console.log(item);
      item.item.sources = this.dev;
    },
    openExportDialog() {
      this.exportDialog = true;
      this.$refs.uploadform.reset();
    },
    closeExportDialog() {
      this.exportDialog = false;
    },
    open() {
      this.$refs.file.$el.querySelector("input").click();
    },
    async getParametersByCode(code) {
      // this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns(code);

        if (response.data.status_code === 200) {
          this.userTypeDropdown = [
            ...response.data.data.map((ele) => {
              return {
                text: ele.value,
                value: ele.value_code,
              };
            }),
            { text: "Both", value: "BOT" },
          ];
        }
      } catch (error) {
        console.error(error);
      }
    },
    async SubmitFile() {
      const validate = this.$refs.uploadform.validate();
      if (validate) {
        this.loader = true;
        const document = new FormData();
        document.append("document", this.document);
        try {
          const responseData = await setupService.importMasterDataFiles(
            this.$route.query.id,
            document
          );
          if (responseData && responseData.data.status_code === 200) {
            this.loader = false;
            this.showAlertSuccess(responseData.data.message);
            this.getallparametersvalue();
            this.success = responseData.data.data[0].no_of_success;
            this.failure = responseData.data.data[0].no_of_failure;
            this.total_records = responseData.data.data[0].total_records;
          } else {
            this.showAlertError(responseData.data.message);
            this.loader = false;
          }
        } catch (error) {
          this.loader = false;
          console.log(error);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async downloadExcelsheet() {
      if (this.allparametersvalues) {
        this.exportToExcel(
          this.headers,
          this.allparametersvalues,
          "parameters_List"
        );
      }
    },
    async validateparameterCode() {
      try {
        const responseData = await setupService.getValidateParValCode(
          this.$route.query.id,
          this.prametervalues.value_code,
          this.prametervalues.user_type
        );
        if (responseData && responseData.data.status_code == 200) {
          this.isavalaiblevalue = responseData.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.validateparameterCode();
        // }
        else if (responseData.data.status_code == 409) {
          this.isavalaiblevalue = responseData.data;
        }
        console.log("validateparameterCode", responseData);
      } catch (e) {
        console.log("ss " + e);
        this.isavalaiblevalue = {
          message: "Something went wrong",
          data: [],
          status_code: 409,
          success: false,
        };
      }
    },
    async validateparameterName() {
      try {
        const responseData = await setupService.getValidateParValName(
          this.$route.query.id,
          this.prametervalues.value,
          this.prametervalues.user_type
        );
        this.loader = false;
        if (responseData && responseData.data.status_code == 200) {
          this.isnameavalaible = responseData.data;
        } else if (responseData.data.status_code == 409) {
          this.isnameavalaible = responseData.data;
        }
        console.log("validateparameterCode", responseData);
      } catch (e) {
        console.log("ss " + e);
        this.isnameavalaible = {
          message: "Something went wrong",
          data: [],
          status_code: 409,
          success: false,
        };
      }
    },
    async getallparametersvalue() {
      this.loader = true;
      if (
        this.searchInputs.customer_type &&
        this.searchInputs.customer_type != "ALL"
      ) {
        var params = {
          user_type: this.searchInputs.customer_type,
        };
      }
      try {
        const responseData = await setupService.getParametersValues(
          this.$route.query.id,
          params
        );
        this.loader = false;
        if (responseData && responseData.data.status_code == 200) {
          this.allparametersvalues = responseData.data.data[0].parameter_values;
          this.is_sub_parameter = responseData.data.data[0].is_sub_parameter;
        }
        console.log(
          "getallparameterscode",
          responseData.data.data[0].parameter_values[0]
        );
        console.log(" this.allparametersvalues", this.allparametersvalues);
      } catch (e) {
        console.log(e);
        this.loader = false;
      }
    },

    onclickNext() {
      console.log(`prametervalues: ${JSON.stringify(this.prametervalues)}`);
      this.postList();
      this.selected = null;
    },

    onClickBack() {
      this.dialog = false;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.selected = null;
      this.isavalaiblevalue = {};
      // this.isavalaiblecode = {}
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 200);
    },

    async postList() {
      const validate = this.$refs.form.validate();
      const namesuccess = this.masterDataRange.includes(this.$route.query.code)
        ? true
        : this.isnameavalaible.success;
      if (validate & namesuccess & this.isavalaiblevalue.success) {
        this.loader = true;
        if (this.editedIndex > -1) {
          Object.assign(
            this.allparametersvalues[this.editedIndex],
            this.prametervalues
          );
        } else {
          const params = {
            user_type: this.prametervalues.user_type,
            value: this.masterDataRange.includes(this.$route.query.code)
              ? `${this.parameter_minvalue}-${this.parameter_maxvalue}`
              : this.prametervalues.value,
            value_code: this.prametervalues.value_code,
            description: this.prametervalues.description,
          };
          try {
            setTimeout(() => {
              this.loader = false;
            }, 300);
            const responseData = await setupService.addParameterValueDetails(
              this.$route.query.id,
              params
            );
            console.log(`responseData: ${JSON.stringify(responseData)}`);
            if (responseData && responseData.data.status_code == 200) {
              this.showAlertSuccess(responseData.data.message);
              this.loader = false;
              this.getallparametersvalue();
            }
            //  else if (responseData.data.status_code === 401) {
            //   this.returnNewToken();
            //   this.postList();
            // }
            else {
              this.showAlertError(responseData.data.message);
            }
            console.log("respose data", responseData);
          } catch (e) {
            console.log(e);
            this.showAlertError("Something went wrong please try again later.");
            this.loader = false;
          }
        }

        this.onClickBack();
      }
    },
    openDialog() {
      this.dialog = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.prametervalues = {
        user_type: this.searchInputs.customer_type
          ? this.searchInputs.customer_type
          : "",
        value: "",
        value_code: "",
        description: "",
      };
      this.parameter_minvalue = null;
      this.parameter_maxvalue = null;
      this.selected = "option1";
    },
    editItem(item) {
      this.dialog = true;
      this.parameter_minvalue = item.value.split("-")[0];
      this.parameter_maxvalue = item.value.split("-")[1];
      this.prametervalues = {
        user_type: item.user_type,
        value: item.value,
        value_code: item.value_code,
        description: item.description,
        id: item.id,
      };
    },

    onupdate() {
      this.update();
      this.selected = null;
    },
    async update() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        if (this.editedIndex < -1) {
          Object.assign(
            this.allparametersvalues[this.editedIndex],
            this.prametervalues
          );
        } else {
          try {
            const responseData = await setupService.updateParameterValueDetails(
              this.prametervalues.id,
              this.prametervalues
            );
            setTimeout(() => {
              this.loader = false;
            }, 300);
            if (responseData && responseData.data.status_code == 200) {
              this.showAlertSuccess(responseData.data.message);
              this.getallparametersvalue();
            }
            // else if (responseData.data.status_code === 401) {
            //   this.returnNewToken();
            //   this.update();
            // }
            else {
              this.showAlertError(responseData.data.message);
            }
            console.log("respose data", responseData);
          } catch (e) {
            console.log(e);
            this.showAlertError("Something went wrong please try again later.");
          }
          setTimeout(() => {
            this.loader = false;
          }, 300);
        }

        this.onClickBack();
      }
    },
    async isactiveupdate(isactive) {
      this.loader = true;
      if (this.editedIndex < -1) {
        Object.assign(
          this.allparametersvalues[this.editedIndex],
          this.prametervalues
        );
      } else {
        try {
          const responseData = await setupService.activateUpdateParValDetails(
            isactive.id,
            isactive.is_active,
            {}
          );
          console.log(`responseData: ${JSON.stringify(responseData)}`);
          setTimeout(() => {
            this.loader = false;
          }, 300);
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getallparametersvalue();
          }
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.isactiveupdate(isactive);
          // }
          else {
            this.showAlertError(responseData.data.message);
          }
          console.log("respose data", responseData);
        } catch (e) {
          console.log(e);
          this.showAlertError("Something went wrong please try again later.");
        }
        setTimeout(() => {
          this.loader = false;
        }, 400);
      }
    },

    deleteItem(item) {
      console.log("item", item);
      this.dialogDelete = true;
      this.deleteId = item.id;
    },

    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteParameterValDetails(
          this.deleteId
        );
        setTimeout(() => {
          this.loader = false;
        }, 300);
        this.response = responseData;
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getallparametersvalue();
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.deleteItemConfirm();
        // }
        else {
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.showAlertError("Something went wrong please try again later.");
      }
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        // this.prametervalues = Object.assign({}, this.defaultItem)
        this.editedIndex = -1;
        this.deleteId = "";
      });
    },
    back() {
      this.$router.push({
        name: "Master Data",
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
label {
  font-size: 15px;
  color: black;
  margin-bottom: 0px !important;
}
.v-dialog .v-card {
  overflow: hidden !important;
}
.label.v-label.theme--light {
  margin-bottom: 0px !important;
}
.v-text-field__prepend-inner {
  border-left: 1px solid #c5c5c5;
  margin-left: 8px;
  padding-left: 8px;
}
.align {
  align-items: center;
}

.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.text-red {
  color: red;
  font-weight: 700;
}
.text-success {
  font-weight: 700;
}
</style>
